import React from 'react'
import { Button } from '@enamelai/design-system'
import { Icon as StarIcon } from '@enamelai/design-system/icons/Star1'

type AddViewButtonProps = {
  handleSaveView: (viewId?: string) => Promise<void>
}

const AddViewButton = ({
  handleSaveView,
}: AddViewButtonProps): React.ReactElement => {
  return (
    <Button
      variant="secondary"
      size="md"
      className="reports-view-action-button"
      leftIcon={<StarIcon className="reports-view-action-icon" aria-hidden />}
      aria-label="Add this view"
      title="Add this view"
      onClick={() => handleSaveView()}
    />
  )
}

export default AddViewButton
